/**
 * Element.closest Polyfill
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */
 if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

/**
 * CustomEvent() constructor polyfill
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
 * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
 */
(function(){
    if ('function' === typeof window.CustomEvent) return false;
    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent('CustomEvent');
       evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    window.CustomEvent = CustomEvent;
})();

window.jfs = window.jfs || {};

/**
 * Return date object in a formatted string: "YYYY-MM-DD"
 */
jfs.getFormattedDate = function(date) {
    var formattedDate = '';
    if (date instanceof Date) {
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = date.getDate();
        d = d < 10 ? '0' + d : d;
        formattedDate = date.getFullYear() + '-' + m + '-' + d;
    }
    return formattedDate;
}

/**
* Returns the number of lines in a textarea, including wrapped lines.
*
* __NOTE__:
* [textarea] should have an integer line height to avoid rounding errors.
*/
jfs.textareaBuffer = null;
jfs.countLines = function(textarea) {
    if (jfs.textareaBuffer == null) {
        jfs.textareaBuffer = document.createElement('textarea');
        jfs.textareaBuffer.style.border = 'none';
        jfs.textareaBuffer.style.height = '0';
        jfs.textareaBuffer.style.overflow = 'hidden';
        jfs.textareaBuffer.style.padding = '0';
        jfs.textareaBuffer.style.position = 'absolute';
        jfs.textareaBuffer.style.left = '0';
        jfs.textareaBuffer.style.top = '0';
        jfs.textareaBuffer.style.zIndex = '-1';
        document.body.appendChild(jfs.textareaBuffer);
    }

    var cs = window.getComputedStyle(textarea);
    var pl = parseInt(cs.paddingLeft);
    var pr = parseInt(cs.paddingRight);
    var lh = parseInt(cs.lineHeight);

    // [cs.lineHeight] may return 'normal', which means line height = font size.
    if (isNaN(lh)) lh = parseInt(cs.fontSize);

    // Copy content width.
    jfs.textareaBuffer.style.width = (textarea.clientWidth - pl - pr) + 'px';

    // Copy text properties.
    jfs.textareaBuffer.style.font = cs.font;
    jfs.textareaBuffer.style.letterSpacing = cs.letterSpacing;
    jfs.textareaBuffer.style.whiteSpace = cs.whiteSpace;
    jfs.textareaBuffer.style.wordBreak = cs.wordBreak;
    jfs.textareaBuffer.style.wordSpacing = cs.wordSpacing;
    jfs.textareaBuffer.style.wordWrap = cs.wordWrap;

    // Copy value.
    jfs.textareaBuffer.value = textarea.value;

    var result = Math.floor(jfs.textareaBuffer.scrollHeight / lh);
    if (result == 0) result = 1;
    return result;
};
